/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/progress_medium'
export default icon
